<template>
  <div>
    <div class="classBnaer">
      
    </div>
    
  </div>
</template>
<script>
import { toExamUQDetailNew, findUQStateNew, getFaceConfig,compareAndSavePhoto } from '../../../api/study';
export default {
  components: {},
  data() {
    return {
      tableData: [],
      examInfo: '', //考试详情
      uqId: '',
      dialogVisible: false,
      cameraFalg: false,
      showImg: '',
      imgUrl: '',
      videoWidth: 470,
      videoHeight: 470,
      //相机截图工具
      face_back_canvas: null,
      //截图内容
      face_back_context: null,
      //照片的base64码值
      face_back_base64Photo: '',
      thisCancas: null,
      thisContext: null,
      thisVideo: null,
      userphoto: '', //用户的头像。拿拍照的图片和头像对比是否本人
      learn_faceMatch_backstagePhoto_score: '' //分数
    };
  },

  computed: {},

  watch: {},

  methods: {
    //获取人脸识别参数
    getFaceConfig() {
      getFaceConfig().then(res => {
        this.captureCount = res.data.data.captureCount;
        this.alreadyPhotoCount = res.data.data.alreadyPhotoCount;
        this.faceConfigFlag = res.data.data.faceConfigFlag;
        this.intervalSeconds = res.data.data.intervalSeconds;
        this.userphoto = res.data.data.userPhoto; //头像
        this.learn_faceMatch_backstagePhoto_score = res.data.data.faceConfigScore; //分数
        if (this.userphoto == '') {
          this.$alert('该学习需要进行人脸识别，请先上传本人头像后再来学习！', '温馨提示', {
            confirmButtonText: '确定',
            callback: action => {
              this.$parent.nav(4);
            }
          });
          return false;
        }
        // if (res.data.data.alreadyPhotoCount >= parseInt(res.data.data.captureCount)) {
        //   this.cameraFalg = false;
        //   return false;
        // }
      });
    },
    // 调用权限（打开摄像头功能）
    async getCompetence() {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({ video: true });
        this.$refs.videoCamera.srcObject = stream;
      } catch (error) {
        this.$alert('无法访问摄像头!，请确认电脑摄像头功能正常后再来学习~', '温馨提示', {
          confirmButtonText: '确定',
          callback: action => {
            this.$parent.nav(8);
          }
        });
      }
    },
    //  绘制图片（拍照功能）
    setImage() {
      let _this = this;
      let canvas = document.getElementById('canvasCamera');
      //相机截图工具
      _this.face_back_canvas = document.getElementById('canvasCamera');
      //截图内容
      _this.face_back_context = document.getElementById('canvasCamera').getContext('2d');
      try {
        let videow = document.getElementById('videoCamera').clientWidth;
        let videoh = document.getElementById('videoCamera').clientHeight;
        _this.face_back_canvas.setAttribute('width', videow);
        _this.face_back_canvas.setAttribute('height', videoh);
        _this.face_back_context.drawImage(document.getElementById('videoCamera'), 0, 0, videow, videoh);
        _this.face_back_base64Photo = canvas.toDataURL('image/jpeg', 1);
        _this.showImg = true;
        _this.imgUrl = _this.face_back_base64Photo;
        _this.carmerShow = false;
        let data = {
          photoType: 'learn_facaMatch_backstagePhoto_pc',
          photoWay: 'photo_way_facaMatch',
          userphoto: _this.userphoto,
          base64Photo: _this.face_back_base64Photo,
          learn_faceMatch_backstagePhoto_score: _this.learn_faceMatch_backstagePhoto_score,
          userQuizId: this.uqId
        };
        const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        setTimeout(() => {
          loading.close();
        }, 10000);
        compareAndSavePhoto(data).then(res => {
          console.log(res.data.data.isPhotoCountFull);
          loading.close();
          if (res.data.data.isPassFlag) {
            //通过
            _this.$message({
              message: res.data.data.msg,
              type: 'success'
            });
            _this.$router.push({
              path: '/questions',
              query: {
                id: _this.uqId,
                classId: _this.$route.query.classId
              }
            });
          } else {
             _this.$message.error(res.data.data.faceMatchResult);
              setTimeout(() => {
                _this.showImg = false;
                _this.imgUrl = '';
                _this.face_back_base64Photo = '';
                _this.getCompetence();
              }, 1000);
          }
        });
      } catch (e) {
        console.log(e);
      }
    },
    //考卷回顾
    toPreview(uqdId) {
      // console.log(this.tableData[this.active]);
      // if (this.tableData[this.active] == undefined) {
      //   this.$message('未选择试卷！');
      //   return false;
      // }
      // this.dialogVisible = false;
      // console.log(this.active);
      console.log(uqdId, '5555');

      this.$router.push({
        path: '/record',
        query: {
          id: uqdId,
          classId: this.$route.query.classId
        }
      });
      // let data = {
      //   uqdId:this.examkList[this.active].uqdId
      // }
      // toPreview(data).then(res => {
      //   console.log(res);
      // })
    },
    //考试须知
    open(description) {
      console.log(description);
      if ((description = '' || description == null)) {
        this.examInfo.description = '暂无须知';
        this.dialogVisible = true;
        // this.$alert('暂无须知', '考试须知', {
        //   confirmButtonText: '确定',
        //   callback: action => {}
        // });
      } else {
        this.dialogVisible = true;
        // this.$alert(description, '考试须知', {
        //   confirmButtonText: '确定',
        //   callback: action => {}
        // });
      }
    },
    handleClose() {
      this.dialogVisible = false;
    },
    //返回
    goBack() {
      this.$router.push({ path: '/studyMain', query: { tabIndex: 8 } });
      this.$parent.nav(8);
    },
    //获取考试详情
    getExam() {
      const data = {
        classId: this.$route.query.classId,
        quizType: '04'
      };
      toExamUQDetailNew(data).then(res => {
        this.uqId = res.data.data.uqId;
        this.examInfo = res.data.data;
        this.tableData = res.data.data.examUQDetailList;
      });
    },
    // toPreview(){

    // },
    //去参加考试
    gotoExam() {
      const data = {
        uqId: this.uqId
      };
      findUQStateNew(data).then(res => {
        console.log(res.data.data.state, '99');
        if (res.data.data.state == '01') {
          //第一次进去永远需要人脸识别，根据字段
          if (this.faceConfigFlag == '01') {
            this.getCompetence();
            this.cameraFalg = true;
          } else {
            //不需要识别
            this.cameraFalg = false;
            this.$router.push({
              path: '/questions',
              query: {
                id: this.uqId,
                classId: this.$route.query.classId
              }
            });
            return false;
          }
        } else if (res.data.data.state == '02') {
          this.$alert('考试已通过无需再次考试！', '温馨提示', {
            confirmButtonText: '确定',
            callback: action => {}
          });
        } else if (res.data.data.state == '03') {
          this.$alert('考试暂未开通，请先完成班级学习！', '温馨提示', {
            confirmButtonText: '确定',
            callback: action => {}
          });
        }
      });
    }
  },

  created() {
    this.getExam();
    console.log(this.$route.query.classId);
  },

  mounted() {},
  beforeCreate() {},
  beforeMount() {}
};
</script>
<style lang="less" scoped>
.cameraBox {
  padding: 0 25px;
  font-family: Medium;
  font-size: 16px;
  .bkBox {
    display: flex;
    justify-content: center;
    position: relative;
    .bk {
      position: absolute;
      top: 0;
      left: 0;
    }
    .box5 {
      margin-top: 10px;
    }
  }
  .camerBtn {
    width: 180px;
    height: 50px;
    background: #4275f5;
    opacity: 1;
    border-radius: 25px;
    font-family: Medium;
    font-size: 16px;
    color: #fff;
    text-align: center;
    line-height: 50px;
    cursor: pointer;
    margin: 28px auto auto auto;
  }
}
.classBnaer {
  width: 1170px;
  background: #fff;
  padding: 20px;
  min-height: 660px;
  border-radius: 6px;
  .classList {
    width: 100%;
    height: 150px;
    border-bottom: 1px #ccc solid;
    display: flex;
    align-items: center;
    .classImg {
      img {
        width: 150px;
        height: 110px;
      }
    }
    .classinfo {
      margin-left: 20px;
      .kcText_1 {
        font-size: 20px;
        width: 500px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .kcText_2 {
        margin-top: 8px;
      }
      .score {
        color: #cd6e6d;
        margin-top: 8px;
      }
    }
    .btn {
      width: 80px;
      height: 30px;
      line-height: 30px;
      text-align: center;
      color: #888888;
      border: 1px solid #888888;
      border-radius: 3px;
      margin-left: 150px;
      cursor: pointer;
    }
  }
}
.btn_1 {
  width: 100%;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  .btn_box {
    font-size: 20px;
    border: 1px solid #2878ff !important;
    color: #2878ff !important;
    width: 140px;
    height: 40px;
    text-align: center;
    border-radius: 5px;
    line-height: 40px;
    cursor: pointer;
  }
}
.group_1 {
  margin-top: 50px;
  .ksTitle {
    display: flex;
    align-items: center;
    font-size: 18px;

    img {
      width: 6px;
      height: 19px;
      margin-right: 5px;
    }
  }
  .table {
    margin-top: 20px;
    ::v-deep {
      .has-gutter {
        th {
          background: #7dbee8;
          color: #fff;
        }
      }
    }
  }
}
.btn_4 {
  display: flex;
  justify-content: center;
  .btn_5 {
    background: #3f76c0;
    color: #fff;
    font-size: 14px;
    cursor: pointer;
    width: 98px;
    text-align: center;
    height: 30px;
    color: #fff;
    line-height: 30px;
    border-radius: 5px;
    margin-top: 20px;
  }
}
</style>
